import { recordError } from 'app/lib/monitoring';
import * as Notifications from 'expo-notifications';
import * as TaskManager from 'expo-task-manager';
import { useEffect } from 'react';
import { Platform } from 'react-native';
import type { DMNotification } from 'app/types/notification';
import { saveNotificationLink } from 'app/lib/notifications';
import { updateBadgeData } from 'app/lib/badge';
import { CustomerIO } from 'customerio-reactnative';
import { changeAppIcon } from 'app/utils/helpers';
import { isMobileNative } from 'app/utils/web-helpers';
import { queryClient } from 'app/lib/react-query';
import { messageKeys } from 'app/network/keys';

const BACKGROUND_NOTIFICATION_TASK = 'BACKGROUND-NOTIFICATION-TASK';

TaskManager.defineTask(BACKGROUND_NOTIFICATION_TASK, async ({ data, error }) => {
  if (data && !error && Platform.OS === 'ios') {
    // For APNS (iOS), when app is NOT in foreground
    console.log('[Expo] Push Notif received from APNS, in background', data);

    changeAppIcon();

    const notification = data as DMNotification;
    const payload = notification.aps?.alert ?? notification.data;
    if (!payload) return;

    saveNotificationLink(payload);

    // Update app icon badge count
    void updateBadgeData(payload, 'apnsBackground');

    // update the unread messages count in the app
    void queryClient.invalidateQueries({ queryKey: messageKeys.unread() });

    // Signal CIO that this notification has been delivered
    console.log(`[CustomerIO.trackNotificationReceived] payload: ${JSON.stringify(notification)}`);
    CustomerIO.pushMessaging.trackNotificationReceived(notification);

    // iOS will already have displayed the received push notification - calling scheduleNotificationAsync() here would show two notifications
  }
});

export const useSetupNotificationsBackgroundTask = () => {
  const registerBackgroundTaskAsync = async () => {
    if (!isMobileNative) return;
    try {
      await Notifications.registerTaskAsync(BACKGROUND_NOTIFICATION_TASK);
      await TaskManager.getRegisteredTasksAsync();
    } catch (e) {
      recordError(e);
    }
  };

  useEffect(() => {
    void registerBackgroundTaskAsync();
  }, []);
};
